import { Tab, Tabs } from '@mui/material';
import { AsyncRenderer } from '../../components/AsyncRenderer/AsyncRenderer';
import { usePersistedTabHash } from '../../hooks/useTabHash';
import { keys } from '../../helpers/general';
import { TitledPage } from '@client/new/components/Misc';
import { DiscountsView } from './view/Discounts.view';
import { useDiscountsVM } from './view-model/discounts.viewModel';
import { Loader } from './view/components/Loader';

const tabs = {
  discounts: 'Discounts',
};

type PromotionsTab = keyof typeof tabs;

const promotionPageTabKey = 'Promotions.Tab';
export const PromotionsPage = () => {
  const vm = useDiscountsVM();

  const { onTabChange, tabHash } = usePersistedTabHash<PromotionsTab>(
    keys(tabs),
    'discounts',
    promotionPageTabKey,
  );

  return (
    <TitledPage title="Promotions">
      <Tabs value={tabHash} onChange={onTabChange}>
        {keys(tabs).map((hash) => (
          <Tab
            key={hash}
            value={hash}
            label={tabs[hash]}
            iconPosition="start"
            style={{
              fontWeight: 500,
              fontSize: '14px',
              fontFamily: 'Visuelt',
              lineHeight: '20px',
              color: 'black',
            }}
          />
        ))}
      </Tabs>
      <div className="mt-5" style={{ maxWidth: '1200px' }}>
        <AsyncRenderer
          data={vm}
          loadRender={<Loader />}
          renderer={(data) => {
            switch (tabHash) {
              case 'discounts':
                return <DiscountsView {...data} />;
            }
          }}
        />
      </div>
    </TitledPage>
  );
};
